export default __webpack_public_path__ + "static/media/storydots-white-logo.b3c9d077.svg";